import { useQuery } from '@tanstack/react-query';
import { chatbotApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useChatUsage(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.chat.usage(),
    queryFn: ({ signal }) => chatbotApiClient.getUsage(toCancelToken(signal)),
    enabled,
    staleTime: 0,
    meta: { silent: true, errorContext: 'chat usage' },
  });
}
